import React, { useEffect, useState, Fragment } from 'react';
import { injectIntl } from 'react-intl';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { renderHeaderButton } from '../../../../../store/headerButtonControl/duck';
import { useDispatch } from 'react-redux';
import './Standard.scss';
import Container from '@mui/material/Container';
import { sanitize } from 'dompurify';
import { SlideTransition } from '../../../../../components/Transition/Transition';

const Layout = props => {
  // console.log('EventStandard props: ', props);
  const { intl, history } = props;

  const dispatch = useDispatch();
  const [event, setEvent] = useState(null);
  // const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!history.location.state || !history.location.state.back) {
      dispatch(renderHeaderButton(true));
    }
    if (history.location.state && history.location.state.item) {
      setEvent(history.location.state.item);
    }
    return () => null;
  }, [history.location]);
  if (!event) {
    return null;
  }

  // const openDialog = () => setOpen(true);
  // const closeDialog = () => setOpen(false);
  const redirect = event?.link ? () => history.push(event.link) : undefined;

  return (
    <Fragment >
      {/* <Dialog open={open} fullWidth={true} TransitionComponent={SlideTransition}>
        <DialogTitle>{intl.formatMessage({ id: 'partner-redirect-dialog-title' })}</DialogTitle>
        <DialogContent>{intl.formatMessage({ id: 'partner-redirect-dialog-content' })}</DialogContent>
        <DialogActions>
          <Button color="primary" onClick={closeDialog}>
            {intl.formatMessage({ id: 'Cancel' })}
          </Button>
          <Button color="primary" onClick={redirect}>
            {intl.formatMessage({ id: 'OK' })}
          </Button>
        </DialogActions>
      </Dialog> */}
      <div style={{ background: '#fff' }}>
        <Container className="partnership-details event" maxWidth="sm">
          <div className="partnership-content">
            <div className="partnership-main-img">
              <img src={event.bannerSrc} />
            </div>
            <div className="partnership-title">
              <h3>{event.title}</h3>
            </div>
            <div
              className="partnership-main-text"
              dangerouslySetInnerHTML={{ __html: sanitize(event.content) }}
            ></div>
            {event.terms && <div className="partnership-terms">{event.terms}</div>}
          </div>
          <div className="more-details" >
            <Button variant="contained" color="primary" onClick={redirect}>
              {event.cta ?? intl.formatMessage({ id: 'event-default-cta' })}
            </Button>
          </div>
        </Container>
      </div>
    </Fragment>
  );
};

export default injectIntl(Layout);
